import {Component, inject, OnInit} from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import {DataSourceComponent} from "./data-source/data-source.component";
import {SupplierSystemsService} from "../../services/supplier-systems/supplier-systems.service";
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import {SortByPipe} from "../../pipes/sort-by.pipe";

@Component({
  selector: 'data-sources',
  standalone: true,
  imports: [NzIconModule, DataSourceComponent, NzSkeletonModule, NzToolTipModule, SortByPipe],
  templateUrl: './data-sources.component.html',
  styleUrl: './data-sources.component.scss'
})
export class DataSourcesComponent implements OnInit {
  supplierSystemsService = inject(SupplierSystemsService)
  loading= true;
  dataSources: any = [];

  ngOnInit() {
    this.supplierSystemsService.getSupplierSystems().subscribe( {
      next: (res)=> {
        this.dataSources = res;
        this.loading = false;
      },
      error: ()=>{
        this.loading = false;
      }
    })
  }

}
